import { Component } from '@verndale/core';
import { gsap } from 'gsap';

import { debounce } from '../../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      imageContainer: this.el.querySelector(
        '.roundshot-mountain-cam__image-slider'
      )
    };

    this.animationType = this.el.dataset.animationType || 'bounce';
    this.loopDuration = this.el.dataset.duration || 150;
    this.bounceDuration = this.el.dataset.duration || 15;

    this.loadModel();
    this.buildSlider();
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.buildSlider.bind(this), 200)
    );
    this.dom.image.addEventListener('load', this.buildSlider.bind(this));
  }

  loadModel() {
    this.model = JSON.parse(this.el.dataset.camModel);

    this.dom.image = document.createElement('img');
    this.dom.image.src = this.model.picture;

    this.dom.imageContainer.appendChild(this.dom.image);
  }

  buildSlider() {
    const imageWidth = this.dom.image.offsetWidth;

    if (this.slider) {
      this.slider.kill();
    }

    if (imageWidth) {
      this.dom.imageContainer.innerHTML = '';
      this.dom.imageContainer.appendChild(this.dom.image);

      if (this.animationType === 'loop') {
        let diff = this.dom.imageContainer.offsetWidth;
        while (diff > 0) {
          const imgClone = this.dom.image.cloneNode();
          imgClone.classList.add('clone');
          this.dom.imageContainer.appendChild(imgClone);

          diff -= imageWidth;
        }
      }

      this.animateSlider();
    }
  }

  animateSlider() {
    const imageWidth = this.dom.image.offsetWidth;
    const containerWidth = this.dom.imageContainer.offsetWidth;

    if (this.animationType === 'loop') {
      const slides = this.dom.imageContainer.querySelectorAll('img');
      const totalWidth = imageWidth * slides.length;
      const mod = gsap.utils.wrap(-imageWidth, totalWidth - imageWidth);

      gsap.set(slides, { x: i => i * imageWidth });

      this.slider = gsap.timeline().to(slides, {
        x: `-=${totalWidth}`,
        modifiers: {
          x: x => `${mod(parseFloat(x))}px`
        },
        duration: this.loopDuration,
        ease: 'none',
        repeat: -1
      });
    } else {
      gsap.set(this.dom.image, { x: 0 });

      this.slider = gsap
        .timeline({ repeat: -1, yoyo: true })
        .to(this.dom.image, {
          x: containerWidth - imageWidth,
          duration: this.bounceDuration,
          ease: 'power1.inOut'
        });
    }
  }
}

export default Module;
